import mainConstants from '../constants/main';

const setCameFrom = (referrer) => (dispatch) => {
  if (!referrer) {
    return null;
  }

  return dispatch({
    type: mainConstants.SET_CAME_FROM,
    payload: referrer,
  });
};

const setUrlParameters = (data) => (dispatch) => {
  if (!data) {
    return null;
  }

  return dispatch({
    type: mainConstants.SET_URL_PARAMETERS,
    payload: data,
  });
};

export const commonActions = {
  setCameFrom,
  setUrlParameters,
};
